import { addToCartButtonStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton";
import { descriptionStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsDescription";
import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { productCopyCss } from "@SupplyLand/Utilities/richTextStyles";
import { css } from "styled-components";

addToCartButtonStyles.button = {
    css: css`
        width: auto;
    `,
};

pageTitleStyles.titleText = {
    variant: "h1",
    css: css`
        font-size: 32px !important;
    `,
};

// L4 description (desktop): Montserrat 15px/500, bold only on the descriptor that opens each bullet
descriptionStyles.wrapper = {
    css: css`
        margin-bottom: 15px;
        ${productCopyCss}
    `,
};
